import { EditableTitle } from 'src/components/atoms';
import { useTheme } from 'styled-components';
import { StyledIconStyled, TagTypeTitleStyled } from './TagTypeTitle.styles';

interface Props {
  index: number;
  name: string;
}

export const TagTypeTitle = ({ name }: Props) => {
  const theme = useTheme();
  return (
    <TagTypeTitleStyled>
      <StyledIconStyled
        size="20px"
        className="uil-arrows-v"
        color={theme.atlas.semantic.color.type.default}
      />

      <EditableTitle
        value={name}
        setValue={() => {}}
        disabled={true}
        data-testid="tag-type-name"
      />
    </TagTypeTitleStyled>
  );
};
